import { useMemo } from 'react';
import { EmotionValue } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import dislike from '../assets/dislike.png';
import average from '../assets/average.png';
import like from '../assets/like.png';
import love from '../assets/love.png';
import { Emotion } from '../components/EmotionSelector/EmotionSelector';

import { useI18n } from './useI18n';

export const useEmotions = () => {
    const i18n = useI18n();

    return useMemo(() => {
        const emotions = {
            DISLIKE: {
                value: 'DISLIKE',
                name: i18n('emotions__dislike'),
                icon: dislike,
            },
            NEUTRAL: {
                value: 'NEUTRAL',
                name: i18n('emotions__average'),
                icon: average,
            },
            LIKE: {
                value: 'LIKE',
                name: i18n('emotions__like'),
                icon: like,
            },
            LOVE: {
                value: 'LOVE',
                name: i18n('emotions__love'),
                icon: love,
            },
        } as Record<EmotionValue, Emotion>;

        return {
            getCurrentEmotion: (emotionValue: EmotionValue | null) =>
                emotionValue ? emotions[emotionValue] : null,
            emotions,
        };
    }, [i18n]);
};
